import { RegexValidatorResponse } from "../../models/regex/RegexValidator";

export { RegexError };

type Props = {
  error?: RegexValidatorResponse;
};

/**
 * Component designed to show the RegexValidatorResponse.
 * @param props
 * @returns
 */
const RegexError = (props: Props) => {
  return (
    <span className={"regexError groupedErrors"}>
      {/* TODO: use actual key */}
      {props.error &&
        !props.error.valid &&
        props.error.reasons.map((err) => (
          <pre key={`${Math.random()}${err}`} className={"error"}>
            {err}
          </pre>
        ))}
    </span>
  );
};
